
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/knowledge/interview",
      function () {
        return require("private-next-pages/knowledge/interview/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/knowledge/interview"])
      });
    }
  